import { render, staticRenderFns } from "./ImportantDisclosure.vue?vue&type=template&id=da44678e&scoped=true&"
import script from "./ImportantDisclosure.vue?vue&type=script&lang=js&"
export * from "./ImportantDisclosure.vue?vue&type=script&lang=js&"
import style0 from "./ImportantDisclosure.vue?vue&type=style&index=0&id=da44678e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da44678e",
  null
  
)

export default component.exports